/* JW_NL_JS_V1_BEGIN */
if (document.documentElement.lang === 'nl') {
/* jw-wishlist.js — Favoris côté client (localStorage), sans app.
   - PDP : bouton cœur (toggle)
   - Header : icône cœur + compteur
   - Page /pages/favoris : rendu des produits sauvegardés
*/
(function () {
  var KEY = 'jw_wishlist';
  var api = window.JW_WISHLIST = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    },
    set: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    },
    has: function (handle) { return api.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var list = api.get();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      api.set(list);
      api.refresh();
      return i === -1;
    },
    refresh: function () {
      var list = api.get();
      document.querySelectorAll('[data-jw-wishlist]').forEach(function (el) {
        var h = el.getAttribute('data-jw-wishlist');
        el.classList.toggle('is-active', list.indexOf(h) !== -1);
        var label = el.querySelector('[data-jw-wishlist-label]');
        if (label) label.textContent = list.indexOf(h) !== -1 ? 'Uit favorieten verwijderen' : 'Aan favorieten toevoegen';
        el.setAttribute('aria-pressed', list.indexOf(h) !== -1 ? 'true' : 'false');
      });
      var badge = document.querySelector('[data-jw-wishlist-count]');
      if (badge) badge.textContent = list.length > 0 ? list.length : '';
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jw-wishlist]');
    if (btn) {
      e.preventDefault();
      api.toggle(btn.getAttribute('data-jw-wishlist'));
    }
  });

  document.addEventListener('DOMContentLoaded', function () { api.refresh(); });
})();

} else { /* JW_NL_JS_FR_ORIGINAL_V1 */
/* jw-wishlist.js — Favoris côté client (localStorage), sans app.
   - PDP : bouton cœur (toggle)
   - Header : icône cœur + compteur
   - Page /pages/favoris : rendu des produits sauvegardés
*/
(function () {
  var KEY = 'jw_wishlist';
  var api = window.JW_WISHLIST = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    },
    set: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    },
    has: function (handle) { return api.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var list = api.get();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      api.set(list);
      api.refresh();
      return i === -1;
    },
    refresh: function () {
      var list = api.get();
      document.querySelectorAll('[data-jw-wishlist]').forEach(function (el) {
        var h = el.getAttribute('data-jw-wishlist');
        el.classList.toggle('is-active', list.indexOf(h) !== -1);
        var label = el.querySelector('[data-jw-wishlist-label]');
        if (label) label.textContent = list.indexOf(h) !== -1 ? 'Retirer des favoris' : 'Ajouter aux favoris';
        el.setAttribute('aria-pressed', list.indexOf(h) !== -1 ? 'true' : 'false');
      });
      var badge = document.querySelector('[data-jw-wishlist-count]');
      if (badge) badge.textContent = list.length > 0 ? list.length : '';
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jw-wishlist]');
    if (btn) {
      e.preventDefault();
      api.toggle(btn.getAttribute('data-jw-wishlist'));
    }
  });

  document.addEventListener('DOMContentLoaded', function () { api.refresh(); });
})();

}
/* JW_NL_JS_V1_END */